<template>
  <div>
    <v-dialog v-model="showSummary" persistent max-width="800" :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card>
        <v-card-title
          class="headline grey lighten-2 v-card-title__sticky"
          primary-title
        >
          <v-layout row>
            <v-flex xs8>Payment Summary for {{ address }}</v-flex>
            <v-spacer />
            <template v-if="+payment.state === 1">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    flat
                    icon
                    color="black"
                    @click.stop="archivePayment(payment)"
                    v-on="on"
                  >
                    <v-icon>archive</v-icon>
                  </v-btn>
                </template>
                <span>Archive this payment as completed</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    flat
                    icon
                    color="black"
                    @click.stop="sendReport(payment)"
                    v-on="on"
                  >
                    <v-icon>send</v-icon>
                  </v-btn>
                </template>
                <span>Send this payment report to the owner</span>
              </v-tooltip>
              <v-tooltip v-if="+payment.state === 1" bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    flat
                    icon
                    color="black"
                    @click.stop="downloadReportPdf()"
                    v-on="on"
                  >
                    <v-icon>attachment</v-icon>
                  </v-btn>
                </template>
                <span>Download the report for this payment</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    flat
                    icon
                    color="black"
                    @click.stop="confirmDialog = true"
                    v-on="on"
                  >
                    <v-icon>redo</v-icon>
                  </v-btn>
                </template>
                <span>Redo payment</span>
              </v-tooltip>
            </template>
            <template v-else>
              <v-tooltip v-if="+payment.state === 0" bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    flat
                    icon
                    color="black"
                    @click.stop="savePayment()"
                    v-on="on"
                  >
                    <v-icon>save</v-icon>
                  </v-btn>
                </template>
                <span>Save payment</span>
              </v-tooltip>
            </template>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  flat
                  icon
                  color="black"
                  @click.stop="hideSummary()"
                  v-on="on"
                >
                  <v-icon>close</v-icon>
                </v-btn>
              </template>
              <span>Close summary</span>
            </v-tooltip>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md px-0 py-0>
            <v-layout row class="mb-3">
              <v-flex xs6 md4>
                <v-layout row>
                  <v-flex align-self-center shrink mr-2>
                    <v-icon large color="light-green lighten-1 "
                      >calendar_today</v-icon
                    >
                  </v-flex>
                  <v-flex grow>
                    <h3 class="body-1 grey--text lighten-4">Period</h3>
                    <p class="body-2 mb-0 black--text">{{ period }}</p>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-spacer />
              <v-flex xs6 md4>
                <v-layout row>
                  <v-flex align-self-center shrink mr-2>
                    <v-icon large color="warning">calendar_today</v-icon>
                  </v-flex>
                  <v-flex grow>
                    <h3 class="body-1 grey--text lighten-4">Due Date</h3>
                    <p class="body-2 mb-0 black--text">
                      {{ payment.paydue_time | moment('DD MMM YYYY') }}
                    </p>
                  </v-flex>
                </v-layout>
              </v-flex>


            <v-flex xs6 md4>
              <v-layout row>
                <v-flex align-self-center shrink  mr-2>
                  <v-icon large color="primary">calendar_today</v-icon>
                </v-flex>
                <v-flex grow>
                  <v-menu
                    v-model="displayPayTime"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <h3 class="body-1 grey--text lighten-4">Pay Date</h3>
                      <p class="body-2 mb-0 black--text" v-on="on">
                        {{ (payment.pay_time||today) | moment('DD MMM YYYY') }}
                      </p>
                    </template>
                    <v-date-picker
                      v-model="payment.pay_time"
                      no-title
                      @input="displayPayTime = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-flex>


            </v-layout>

            <v-layout row class="mb-2">
              <v-flex xs5>
                <h2 class="title">
                  <v-icon color="primary">person</v-icon>Owner
                </h2>
                <v-divider class="my-2 primary" />
                <v-list dense>
                  <v-list-tile class="mb-2">
                    <v-list-tile-content>
                      <v-list-tile-title>{{
                        house.owner_firstname + ' ' + house.owner_lastname
                      }}</v-list-tile-title>
                      <v-list-tile-sub-title>Name</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile class="mb-2">
                    <v-list-tile-content>
                      <v-list-tile-title>{{
                        house.owner_phone
                      }}</v-list-tile-title>
                      <v-list-tile-sub-title>Phone</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>{{
                        house.owner_email
                      }}</v-list-tile-title>
                      <v-list-tile-sub-title>Email</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
              <v-flex xs6>
                <h2 class="title">
                  <v-icon color="primary">person</v-icon>Tenants
                </h2>
                <v-divider class="my-2 primary" />
                <!-- <template v-if="Object.keys(tenant).length > 0"> -->
                  <template v-if="Object.keys(tenant) && Object.keys(tenant).length > 0">
                  <v-layout row>
                    <v-flex xs6>
                      <v-list dense>
                        <v-list-tile class="mb-2">
                          <v-list-tile-content>
                            <v-list-tile-title>
                              {{ tenant.tenant_name }}
                            </v-list-tile-title>
                            <v-list-tile-sub-title>Name</v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile class="mb-2">
                          <v-list-tile-content>
                            <v-list-tile-title>
                              {{ tenant.tenant_phone }}
                            </v-list-tile-title>
                            <v-list-tile-sub-title>Phone</v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                          <v-list-tile-content>
                            <v-list-tile-title>
                              {{ tenant.tenant_email }}
                            </v-list-tile-title>
                            <v-list-tile-sub-title>Email</v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-flex>
                  </v-layout>
                </template>
              </v-flex>
            </v-layout>

            <v-layout row>
              <h2 class="title display--block">
                <v-icon color="primary">attach_money</v-icon>Pay Information
              </h2>
            </v-layout>
            <v-divider class="my-2 primary" />

            <v-layout row mb-2>
              <v-flex xs2>
                <v-list dense>
                  <v-list-tile class="mb-2">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <span class="subheading">{{
                          '$' + payment.pay_amount
                        }}</span>
                      </v-list-tile-title>
                      <v-list-tile-sub-title>Rent</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
              <v-flex xs3>
                <v-list dense>
                  <v-list-tile class="mb-2">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <span class="subheading">{{
                          '$' + payment.manager_fee
                        }}</span>
                      </v-list-tile-title>
                      <v-list-tile-sub-title
                        >Management Fee</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
              <v-flex xs3>
                <v-radio-group
                  v-model="payment.mf_gst_status"
                  class="mt-0"
                  :disabled="+payment.state === 1"
                  @change="updateManagementFeeDetails()"
                >
                  <v-radio
                    v-for="(option, key) in gstOptions"
                    :key="key"
                    :value="option.value"
                    color="primary"
                  >
                    <template v-slot:label>
                      <div class="body-1">{{ option.text }}</div>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs2>
                <v-list dense>
                  <v-list-tile class="mb-2">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <span class="subheading">
                          {{ '$' + payment.manager_fee_real }}
                        </span>
                      </v-list-tile-title>
                      <v-list-tile-sub-title>Base Fee</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
              <v-flex xs2>
                <v-list dense>
                  <v-list-tile class="mb-2">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <span class="subheading">
                          {{ '$' + payment.manager_fee_gst }}
                        </span>
                      </v-list-tile-title>
                      <v-list-tile-sub-title>GST</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-layout>
            <v-layout v-if="payment.fee.length > 0" row>
              <h2 class="title display--block">
                <v-icon color="primary">attach_money</v-icon>Fees
              </h2>
            </v-layout>
            <v-divider v-if="payment.fee.length > 0" class="my-2 primary" />
            <template v-if="payment.fee.length > 0">
              <v-layout
                v-for="(fee, feeIndex) in payment.fee"
                :key="feeIndex"
                row
                class="mb-2"
              >
                <v-flex xs3>
                  <v-list dense>
                    <v-list-tile class="mb-2">
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <span class="subheading">
                            {{ getFeeTypeName(fee.fee_type_id) }}
                          </span>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>Type</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-flex>
                <v-flex xs3>
                  <v-list dense>
                    <v-list-tile class="mb-2">
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <span class="subheading">
                            {{ fee.fee_date | moment('DD MMMM YYYY') }}
                          </span>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>Date</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-flex>
                <v-flex xs2>
                  <v-list dense>
                    <v-list-tile class="mb-2">
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <span class="subheading">{{
                            '$' + fee.fee_real
                          }}</span>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>Amount</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-flex>
                <v-flex xs2>
                  <v-list dense>
                    <v-list-tile class="mb-2">
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <span class="subheading">{{
                            '$' + fee.fee_gst
                          }}</span>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>GST</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-flex>
                <v-flex xs2>
                  <v-list dense>
                    <v-list-tile class="mb-2">
                      <v-list-tile-action>
                        <v-btn
                          v-if="+payment.state !== 1"
                          icon
                          @click="removeFeeFromPayment(feeIndex)"
                        >
                          <v-icon color="error">delete</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-flex>
              </v-layout>
            </template>
            <v-layout row>
              <h2 class="title display--block">
                <v-icon color="primary">attach_money</v-icon>Payment to Owner
              </h2>
            </v-layout>
            <v-divider class="my-2 primary" />
            <v-layout row>
              <v-flex>
                <v-list dense>
                  <v-list-tile class="mb-2">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <span class="subheading">{{ '$' + total.toFixed(2) }}</span>
                      </v-list-tile-title>
                      <v-list-tile-sub-title>This term</v-list-tile-sub-title>
                    </v-list-tile-content>
                    <template v-if="lastBalance">
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <span class="subheading">{{ '$' + lastBalance.toFixed(2) }}</span>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>Last carry on</v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-spacer></v-spacer>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <span class="subheading">{{ '$' + (total+lastBalance).toFixed(2) }}</span>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>Amount</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </template>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmDialog" max-width="600" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-3" primary-title>
          <v-icon :color="redoCaution.iconColor">{{redoCaution.iconName}}</v-icon>
          Redo Payment
        </v-card-title>
        <v-card-text>
          <p class="subheading">{{redoCaution.text}}</p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="confirmDialog = false">Cancel</v-btn>
          <v-btn color="primary" @click.stop="redo()">
            <v-icon>redo</v-icon>&nbsp;Redo Payment
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import moment from 'moment'
import alertHelper from '@/helpers/alert'

export default {
  name: 'DetailsPayment',
  data() {
    return {
      showSummary: true,
      confirmDialog: false,
      displayPayTime: false,
      lastBalance: 0,
    }
  },
  computed: {
    ...mapGetters({
      house: 'HouseList/getSelectedHouse',
      existingPayments: 'HouseList/Lease/getPayments',
      tenant: 'HouseList/Lease/getTenant',
      fees: 'HouseList/Fees/get',
      feeTypes: 'Configuration/getFeeTypes',
      gstStatus: 'Configuration/getGstStatus',
      gstOptions: 'Configuration/getGstOptions',
    }),
    today() {
      return moment().toDate();
    },
    payment() {
      let payment = this.$store.getters['HouseList/Lease/getPaymentById'](parseInt(this.$route.params.paymentId))
      if (payment.state === 0) {
        payment.fee = this.fees.filter(f => f.house_id === payment.house_id && f.state === 0);
      }
      //      console.log({payment, fees: this.fees})
      return payment
    },
    address: function() {
      let address = ''

      if (this.house.unit) {
        address += this.house.unit + '/'
      }

      if (this.house.num) {
        address += this.house.num + ' '
      }

      if (this.house.street) {
        address += this.house.street
      }

      return address
    },
    period: function() {
      const from = moment(this.payment.paystart_time).format('DD MMM')
      const to = moment(this.payment.payend_time).format('DD MMM YYYY')
      return from + ' - ' + to
    },
    total: function() {
      let feeTotal = 0

      if (this.payment.fee.length > 0) {
        this.payment.fee.forEach((fee) => {
          feeTotal += Number(fee.fee_real)
          feeTotal += Number(fee.fee_gst)
        })
      }

      return (
        this.payment.pay_amount -
        this.payment.manager_fee_real -
        this.payment.manager_fee_gst -
        feeTotal
      )
    },
    redoCaution() {
      return this.payment.bankfiled
      ? {
          iconColor: 'red',
          iconName: 'notifications_active',
          text: 'Please make sure you removed this payment from the banking file or you will highly likely to make a double pay!'
        }
      : {
          iconColor: 'orange',
          iconName: 'warning',
          text: 'Are you sure you wish to redo this payment? This action cannot be reverted.'
        }
    },
  },
  methods: {
    ...mapActions({
      save: 'HouseList/Lease/savePayment',
      generate: 'HouseList/Lease/downloadPayment',
      sendReport: 'HouseList/Lease/sendPayment',
      archivePayment: 'Payments/archivePayment',
      redoPayment: 'HouseList/Lease/redoPayment',
      getLastBalance: 'HouseList/Payments/getLastBalance',
    }),
    ...mapMutations({
      hideSelectedHouse: 'HouseList/setSelectedHouse',
    }),
    getFeeTypeName: function(id) {
      const filteredFeeType = this.feeTypes.filter(
        (feeType) => feeType.id === id
      )
      return filteredFeeType.length > 0 ? filteredFeeType[0].fee_name : ''
    },
    hideSummary: function() {
      this.$router.go(-1)
    },
    updateManagementFeeDetails: function() {
      this.payment.manager_fee_real = this.payment.manager_fee

      if (this.payment.mf_gst_status === 0) {
        this.payment.manager_fee_gst = 0
      } else if (this.payment.mf_gst_status === 2) {
        this.payment.manager_fee_gst = Number.parseFloat(
          this.payment.manager_fee * 0.15
        ).toFixed(2)
      }
    },
    removeFeeFromPayment: function(index) {
      this.payment.fee.splice(index, 1)
    },
    savePayment: function() {
      // Check the payments before this one are processed
      if (this.canGenerateReport()) {
        this.payment.total_amount = this.total + this.lastBalance;
        this.payment.state = 1
        this.save(this.payment)
      } else {
        alertHelper.error(
          'Action failed. Please make sure all the previous payments are processed.'
        )
      }
    },
    downloadReportPdf: function() {
      const canGenerateReport = this.canGenerateReport()

      if (this.payment.id && canGenerateReport) {
        this.generate(this.payment)
      } else {
        if (!canGenerateReport) {
          alertHelper.error(
            'Sorry, we cannot process your request. Please do not leave any gap between the latest processed payment and your selection.'
          )
        } else {
          alertHelper.error('Please save your payment first')
        }
      }
    },
    /**
     * Checks if the payment before this one is processed
     * We dont want users to process random payments
     */
    canGenerateReport: function() {
      let selectedPaymentIndex = -1
      if (this.existingPayments.length > 0) {
        this.existingPayments.forEach((existingPayment, index) => {
          if (existingPayment.id === this.payment.id) {
            selectedPaymentIndex = index
          }
        })
        return (
          selectedPaymentIndex === 0 ||
          +this.existingPayments[selectedPaymentIndex - 1].state === 1
        )
      }
      return false
    },
    updatePaymentFees: function() {
      if (this.payment.fee.length === 0 && +this.payment.state !== 1) {
        this.payment.fee = []

        if (this.fees.length > 0) {
          this.fees.forEach((fee) => {
            if (fee.state === null || +fee.state === 0) {
              this.payment.fee.push(fee)
            }
          })
        }
      }
    },
    setDefaultManagementGst: function() {
      if (+this.payment.state === 0) {
        this.payment.mf_gst_status = this.gstStatus.value
      }
    },
    redo: async function() {
      this.confirmDialog = false
      await this.redoPayment(this.payment)
      this.updatePaymentFees()
    },
  },
  mounted: async function() {
    this.setDefaultManagementGst();
    this.lastBalance = await this.getLastBalance({id: this.$route.params.paymentId});
    // console.log({mounted : this.$route.params, lastBalance: this.lastBalance})
  },
}
</script>
<style lang="stylus" scoped>
hr {
  border-width: 2px 0 0 0;
}

.v-card-title__sticky {
  position: sticky;
  top: 0;
}
</style>
